import styled, {css} from 'styled-components'

export const StyledPageHeaderContainer = styled.div`
    ${() => css`
        display: grid;
        align-items: start;
        grid-template-columns: 1fr auto;
        margin-bottom: 24px;
    `}
`

export const StyledPageHeaderText = styled.div`
    ${({theme: {spacing, palette, typography}}) => css`
        & h1 {
            color: ${palette.neutral['900']};
            font-family: 'Playfair Display';
            font-weight: 600;
            font-size: 30px;
            margin-bottom: ${spacing}px;
        }
        & p {
            color: ${palette.neutral['600']};
            ${typography.textMd}
        }
    `}
`
